import { DefaultValues } from "react-hook-form";
import ApplicationStepHeader from "../ApplicationStepHeader";
import ApplicationSteps from "../ApplicationSteps";
import DynamicForm, { FieldValues } from "../DynamicForm";
import { FormStepComponent } from "../FormSteps/FormSteps";
import SplitLayout from "../SplitLayout";

const FormScreen = <T extends FieldValues>({
  onNext,
  onPrevious,
  currentStepNumber,
  hasZeroStep,
  numberOfSteps,
  value,
  step,
  steps,
}: FormStepComponent<T>) => {
  const stepNumber = hasZeroStep ? currentStepNumber : currentStepNumber + 1;
  return (
    <SplitLayout>
      <SplitLayout.Aside>
        <ApplicationSteps
          onPrevious={onPrevious}
          steps={steps}
          state={currentStepNumber}
          step={step}
          value={value}
        />
      </SplitLayout.Aside>
      <SplitLayout.Body
        currentStepNumber={currentStepNumber}
        numberOfSteps={numberOfSteps}
        state={currentStepNumber}
      >
        <ApplicationStepHeader
          config={step.config}
          currentStepNumber={stepNumber}
          value={value}
        />
        <DynamicForm
          id="form"
          defaultValues={value as DefaultValues<T>}
          onSubmit={(values) => onNext(values)}
          formDefinition={step.config}
          onPrevious={currentStepNumber > 0 ? () => onPrevious() : undefined}
        />
      </SplitLayout.Body>
    </SplitLayout>
  );
};

export default FormScreen;
